import { ToastProvider } from "@nabble/ui";
import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/Guard";
import { Shell } from "./layout/Shell";
import AccountPage from "./pages/account/AccountPage/AccountPage";
import OverviewPage from "./pages/overview/OverviewPage/OverviewPage";
import { adminCenterRoutes, organizationRoutes } from "./routes/administrationRoutes";
import { publicModuleRoutes, signedInModuleRoutes } from "./routes/moduleRoutes";
import { signedOutRoutes } from "./routes/signedOutRoutes";

const pageLoading = <div className="nb-page-loading" aria-busy="true" aria-label="Loading" />;

/**
 * Modules' public pages (`/p/<module-id>/…`, docs/adr/0015) live outside the
 * session: no AuthProvider, no AppShell, no calls to /api/auth or /api/me.
 * Everything else is the signed-in suite.
 */
export default function App(): React.JSX.Element {
  return (
    <Routes>
      {publicModuleRoutes(pageLoading)}
      <Route path="*" element={<SuiteApp />} />
    </Routes>
  );
}

function SuiteApp(): React.JSX.Element {
  return (
    <AuthProvider>
      <ToastProvider>
        <Suspense fallback={pageLoading}>
          <Routes>
            {signedOutRoutes()}
            <Route
              element={
                <RequireAuth>
                  <Shell />
                </RequireAuth>
              }
            >
              <Route path="/" element={<OverviewPage />} />
              <Route path="/account" element={<Navigate to="/account/profile" replace />} />
              <Route path="/account/:section" element={<AccountPage />} />
              {organizationRoutes()}
              {adminCenterRoutes()}
              {signedInModuleRoutes()}
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </ToastProvider>
    </AuthProvider>
  );
}
